<template>
    <div class="login">
        <div class="login_form">
            <div class="item_form">
                <div class="form_title">原密码</div>
                <div class="form_filed">
                    <van-field v-model="oldPassword" placeholder="请输入原密码" :border="false" type="tel" />
                </div>
            </div>
            <div class="item_form">
                <div class="form_title">新密码</div>
                <div class="form_filed">
                    <van-field v-model="newPassword" placeholder="请输入新密码" :border="false" type="tel" />
                </div>
            </div>
            <div class="item_form">
                <div class="form_title">确认新密码</div>
                <div class="form_filed">
                    <van-field v-model="againPassword" placeholder="请再次输入新密码" type="password" :border="false" />
                </div>
            </div>
            <van-button block :loading="btnLoading" :disabled="submitLoading" class="login_action" @click="login">修改密码</van-button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    name: 'login',
    data() {
        return {
            oldPassword: '',
            newPassword: '',
            againPassword: '',
            token: null,
			submitLoading: false, // 提交loading
			btnLoading: false, // 加载loading
			publicPath: process.env.BASE_URL,
        };
    },
    created: function () {
		// console.log()
		//根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
            //注册方法，右上角设置按钮点击事件
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                responseCallback('success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
        }
    },
    methods: {
        // 登录
        login() {
            var that = this;
            that.submitLoading = true;
            if (!that.oldPassword) {
                that.$toast('请输入原密码');
                that.submitLoading = false;
                return
            }
            if (!that.newPassword) {
                that.$toast('请输入新密码');
                that.submitLoading = false;
                return
            }
            if (!that.againPassword) {
                that.$toast('请再次输入新密码');
                that.submitLoading = false;
                return
            }
            var param = {
                'oldPassword': that.oldPassword,
                'newPassword': that.newPassword
			}
			that.btnLoading = true
            that.$api.my.password(param).then(res => {
                if (res.code === 200) {
					that.$toast('修改密码成功，请重新登录');
					
                } else {
					
                }
			})
		},
		// 获取yanzhengm 
		getCode(){
			this.$toast('正在开发中...')
		},
		// 微信登录
		loginWechat(){
			this.$toast('正在开发中...')
		}
        
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
</style>
